/** @jsxRuntime classic */
/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/react';
import { Tag } from '../../components/Tag';
import { i18n } from '../../lib/i18n';

export const PrivateTag = () => {
	return <Tag title={i18n.private} color="gray" />;
};

